<script setup lang="ts">
import { nextTick, ref } from 'vue'
import { Eye, EyeOff } from 'lucide-vue-next'

// Attrs (class, id, placeholder, autocomplete, listeners) go to the <input>, not the wrapper.
defineOptions({ inheritAttrs: false })

const model = defineModel<string>()
const visible = ref(false)
const input = ref<HTMLInputElement | null>(null)

async function toggle() {
  const el = input.value
  const start = el?.selectionStart ?? null
  const end = el?.selectionEnd ?? null
  visible.value = !visible.value
  await nextTick()
  if (el && start !== null && end !== null && document.activeElement === el) {
    el.setSelectionRange(start, end)
  }
}
</script>

<template>
  <div class="relative">
    <input
      ref="input"
      v-model="model"
      v-bind="$attrs"
      :type="visible ? 'text' : 'password'"
      class="pr-10 [&::-ms-reveal]:hidden"
    />
    <!-- mousedown.prevent keeps focus (and caret) in the input on mouse click; Tab still reaches the button -->
    <button
      type="button"
      :aria-label="visible ? 'Hide password' : 'Show password'"
      :aria-pressed="visible"
      class="absolute inset-y-0 right-0 flex items-center px-3 text-cc-text-secondary hover:text-cc-text focus:outline-none focus-visible:ring-2 focus-visible:ring-cc-primary rounded-r-md"
      @mousedown.prevent
      @click="toggle"
    >
      <EyeOff v-if="visible" class="w-4 h-4" aria-hidden="true" />
      <Eye v-else class="w-4 h-4" aria-hidden="true" />
    </button>
  </div>
</template>
